import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { REACT_APP_SITE_NAME } from '../constants/config'

const mapStateToProps = state => ({
    ...state.common,
})

const mapDispatchToProps = dispatch => ({
})

class RegisterSuccess extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (<div className="main">
            <div className="main-wrap">
                <div className="Sigma">
                    <h2 className='AltTitle'>Thank you for your registration.</h2>
                </div>
            </div>
        </div>)

    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterSuccess))